<script>
import Layout from "../../layouts/main";
import Loader from "@/components/widgets/loader";
// import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import ModelIndex from "@/components/models/index-v2";
import ModelFilter from "@/components/model-filter-v3";
import Stat from "@/components/widgets/stat";

import Swal from "sweetalert2";

import { models } from "./data-models";

export default {
  name: "ViewModel",
  page: {
    title: "Models",
    meta: [
      {
        name: "description",
        content: appConfig.description
      }
    ]
  },
  components: {
    Layout,
    Loader,
    // PageHeader,
    ModelIndex,
    ModelFilter,
    Stat
  },
  props: {
    cardTitle: {
      default() {
        return undefined;
      }
    },
    resourceRoute: { default: "models" },
    modelVariable: { default: "model" },
    queryKey: {
      default: null
    }
  },
  data() {
    return {
      title: this.lodash.upperFirst(this.$t("models.plural")),
      items: [
        {
          text: this.lodash.upperFirst(this.$t("models.plural")),
          href: "/models",
          active: true
        }
      ],
      isInitiated: false,
      loading: false,
      loadingExport: false,
      page: (this.$route.query.page && Number(this.$route.query.page)) || 1,
      perPage: (this.$route.query.per_page && Number(this.$route.query.per_page)) || 10,
      search: this.$route.query.search || "",
      sortBy:
        (this.$route.query.sort &&
          this.$route.query.sort
            .split("|")
            .shift()
            .split(",")
            .shift()) ||
        "name",
      sortDesc:
        (this.$route.query.sort &&
          this.$route.query.sort
            .split("|")
            .shift()
            .split(",")
            .pop() === "desc") ||
        false,
      busy: false,
      models: [],
      from: 1,
      total: 50,
      filter: {},
      filterColumns: {},
      filterHandler: null,
      stats: [],
      routeQueryWatch: true,
      filterWatch: false
    };
  },
  mounted() {
    this.initFilter();
    this.filterWatch = true;
  },
  computed: {
    queryParams() {
      if (this.queryKey) {
        return this.$route.query[this.queryKey] || {};
      }
      return this.$route.query;
    },
    filterParams() {
      let params = {};
      Object.keys(this.filter).forEach(key => {
        if (key.includes(".")) {
          let keys = key.split(".");
          const parent = keys.shift();
          keys = keys.map(key => `[${key}]`).join("");
          params[`${parent}${keys}`] = this.filter[key];
        } else {
          params[key] = this.filter[key];
        }
      });
      let unusedKeyRouterQuery = [];
      unusedKeyRouterQuery = Object.keys(params).filter(key => {
        return params[key] === undefined || params[key] === "";
      });
      unusedKeyRouterQuery.forEach(key => {
        // if (this.filterColumns[key]) {
          delete params[key];
        // }
      });
      return params;
    },
    columns() {
      return {
        [this.modelVariable || "model"]: [
          { key: "index", label: "#", sortable: false, style: { width: "1%" }, tdClass: "align-middle" },
          { key: "action", class: "text-center", style: { width: "1%" }, tdClass: "align-middle" },
          {
            key: "name",
            label: "Name",
            sortable: true,
            tdClass: "align-middle"
          }
        ]
      };
    },
    totalFiltered() {
      return this.total;
    }
  },
  created() {
    Object.keys(this.filterColumns).forEach(key => {
      Object.keys(this.$route.query).forEach(q => {
        if (q.includes(key)) {
          this.filter[q] =
            this.filterColumns[key].type === Array ? this.$route.query[q].split(",") : this.$route.query[q];
        }
      });
    });
  },
  watch: {
    "$route.query": {
      // handler: this.routeQueryChanged,
      handler(value, oldValue) {
        if (this.queryKey) {
          // only triger routeQueryChanged if value !== oldValue
          if (this.lodash.isEqual(value[this.queryKey], oldValue[this.queryKey])) return;
        }
        this.routeQueryChanged(value);
      },
      deep: true
    },
    page(value) {
      this.queryUpdate({ page: value });
    },
    perPage(value) {
      if (this.page !== 1) this.page = 1;
      else this.queryUpdate({ per_page: value });
    },
    search(value) {
      if (this.page !== 1) this.page = 1;
      else this.queryUpdate({ search: value || undefined });
    },
    sortBy(value) {
      this.queryUpdate({ sort: `${value},${this.sortDesc ? "desc" : "asc"}` });
    },
    sortDesc(value) {
      this.queryUpdate({ sort: `${this.sortBy},${value ? "desc" : "asc"}` });
    },
    filter(val, oldVal) {
      let isEqual = this.isEqual(this.lodash.cloneDeep(val), this.lodash.cloneDeep(oldVal))
      let isOldValNotEmpty = this.lodash.isEmpty(oldVal)
      if (!this.filterWatch || isEqual || isOldValNotEmpty) return;
      let filter = {};
      let routerQuery = {};
      let unusedKeyRouterQuery = [];

      Object.keys(oldVal || {}).forEach(key => {
        filter[key] = (val || {})[key];
      });
      filter = { ...filter, ...(val || {}) };
      routerQuery = { ...this.queryParams, ...filter };
      unusedKeyRouterQuery = Object.keys(routerQuery).filter(
        key => routerQuery[key] === undefined || routerQuery[key] === ""
      );
      unusedKeyRouterQuery.forEach(key => delete routerQuery[key]);
      this.routeQueryWatch = false;
      this.$router.push({ query: routerQuery }).finally(() => (this.routeQueryWatch = true));
    }
  },
  methods: {
    routeQueryChanged() {
      if (!this.routeQueryWatch) return;
      this.perPage = this.queryParams?.per_page ? Number(this.queryParams.per_page) : 10;
      this.search = this.queryParams?.search || "";
      this.page = this.queryParams?.page ? Number(this.queryParams.page) : 1;
      this.filterWatch = false;
      this.initFilter();
      this.$nextTick(() => {
        this.filterWatch = true;
      });
    },
    queryUpdate(value = {}) {
      if (this.queryKey) {
        this.$router.push({
          query: {
            ...this.$route.query,
            [this.queryKey]: {
              ...this.queryParams,
              page: this.page,
              per_page: this.perPage,
              search: this.search || undefined,
              sort: `${this.sortBy},${this.sortDesc ? "desc" : "asc"}`,
              ...value
            }
          }
        });
      } else {
        this.$router.push({
          query: {
            ...this.queryParams,
            page: this.page,
            per_page: this.perPage,
            search: this.search || undefined,
            sort: `${this.sortBy},${this.sortDesc ? "desc" : "asc"}`,
            ...value
          }
        });
      }
    },
    initFilter() {
      const columns = Object.keys(this.filterColumns) || [];
      // const query = this.lodash.pickBy(this.$route.query, (value, key) => columns.find((k) => key.startsWith(k)));
      // query to filter
      const query = {};
      columns.forEach(column => {
        // find in query that start with column
        let operator = this.filterColumns[column].operator;
        const filterName = column;
        if (operator !== "undefined") {
          +"__" + operator;
        }
        const queryColumn = Object.keys(this.queryParams).find(key => key.startsWith(column));
        if (queryColumn) {
          query[filterName] = this.queryParams[queryColumn];
        } else {
          query[column] = "";
        }
      });
      this.$set(this, "filter", {
        ...query
      });
    },
    getModelKey(value) {
      return value[this.modelKey || "id"];
    },
    getModelName(value) {
      return value["name"] || this.getModelKey(value);
    },
    modelsPaginated(ctx) {
      return this.fetchModels(ctx.currentPage).then(() => this.models);
    },
    handleCreate() {
      this.$router.push({ path: `create`, append: true });
    },
    handleExport() {
      this.$router.push({ path: `export`, append: true });
    },
    handleShow(value) {
      this.$router.push({ path: `${this.getModelKey(value)}`, append: true });
    },
    handleEdit(value) {
      this.$router.push({ path: `${this.getModelKey(value)}/edit`, append: true });
    },
    deleteConfirmAlert() {
      return Swal.fire({
        title: this.$t("Are you sure?"),
        text: this.$t(`You won't be able to revert this!`),
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill mx-1",
        cancelButtonClass: "btn btn-danger btn-fill mx-1",
        confirmButtonText: this.$t("Yes, delete it!"),
        cancelButtonText: this.$t("Cancel"),
        buttonsStyling: false
      });
    },
    deleteSuccessAlert(something) {
      return Swal.fire({
        title: this.$t("Deleted") + "!",
        text: this.$t(`You deleted {something}`, { something }),
        type: "success",
        confirmButtonClass: "btn btn-success btn-fill",
        buttonsStyling: false
      });
    },
    failedAlert(error) {
      return Swal.fire({
        title: this.$t("Failed") + "!",
        text: (error.response && (error.response.data || {}).message) || error.message,
        type: "danger",
        confirmButtonClass: "btn btn-danger btn-fill",
        buttonsStyling: false
      });
    },
    delete(value) {
      return Promise.resolve({ data: value });
    },
    handleDelete(value) {
      this.deleteConfirmAlert().then(result => {
        if (result.value) {
          this.delete(value)
            .then(() => this.$refs.table.$refs.table.refresh())
            .then(() => this.deleteSuccessAlert(this.getModelName(value)))
            .catch(error => {
              this.failedAlert(error);
              return null;
            });
        }
      });
    },
    fetchModels(page = 1) {
      let perPageModels = this.lodash.chunk(models, this.perPage)[page - 1] || [];
      return Promise.resolve({
        data: {
          data: perPageModels,
          meta: {
            current_page: page,
            per_page: this.perPage,
            from: this.perPage * (page - 1) + 1,
            total: models.length
          }
        }
      })
        .then(response => {
          const {
            data: { data, meta }
          } = response;
          this.models = data.map(datum => ({
            ...datum,
            _denyShow: false,
            _denyEdit: false,
            _denyDelete: false
          }));
          this.page = Number(meta.current_page);
          this.perPage = Number(meta.per_page);
          this.from = Number(meta.from);
          this.total = Number(meta.total);

          return response;
        })
        .catch(error => {
          this.failedAlert(error);
          return null;
        });
    },
    isEqual(a, b) {
      let keysA = Object.keys(a);
      let keysB = Object.keys(b);
      if (keysA.length !== keysB.length) return false;
      for (let key of keysA) {
        if (!b.hasOwnProperty(key)) return false;
        let valAEmptyOrUndefined = a[key] === '' || a[key] === undefined;
        let valBEmptyOrUndefined = b[key] === '' || b[key] === undefined;
        if (valAEmptyOrUndefined && valBEmptyOrUndefined) {
          continue;
        }
        if (a[key] !== b[key]) return false;
      }

      return true;
    }
  }
};
</script>

<template>
  <Layout>
    <!-- <PageHeader v-if="title" :title="title" :items="items" /> -->

    <Loader :loading="loadingExport" no-axios>
      <div class="">
        <div v-if="stats.length" class="row">
          <div class="title">{{ lodash.upperCase(title) }}</div>
          <div v-for="stat of stats" :key="stat.icon" :class="stat.wrapperClass">
            <Stat v-bind="stat" :loading="busy" />
          </div>
        </div>
        <div v-if="!lodash.isEmpty(filterColumns)">
          <model-filter
            v-model="filter"
            :columns="filterColumns"
            :modelVariable="modelVariable"
            :filterHandler="filterHandler"
          />
        </div>
      </div>
      <div class="title">{{ lodash.upperCase($t("List")) }} {{ lodash.upperCase(title) }}</div>
      <div class="row">
        <model-index
          ref="table"
          class="col-12"
          :loading="loading"
          v-bind="$props"
          :columns="columns"
          :busy.sync="busy"
          :models-paginated="modelsPaginated"
          :page.sync="page"
          :per-page.sync="perPage"
          :from="from"
          :total="totalFiltered"
          :search.sync="search"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :filter-params.sync="filterParams"
          @create-click="handleCreate"
          @export-click="handleExport"
          @show-click="handleShow"
          @edit-click="handleEdit"
          @delete-click="handleDelete"
        >
        </model-index>
      </div>
    </Loader>
  </Layout>
</template>

<style>
.title {
  font-weight: 800;
  font-size: 14px !important;
  color: #6c7589 !important;
  letter-spacing: 0.05em;
  margin-bottom: 8px;
}
</style>

<style lang="scss" scoped>
::v-deep {
  .page-content {
    background: #eef3f7 !important;
    font-family: Lato;
    color: #161b4d;
  }

  .page-title-box {
    padding-bottom: 4px;
  }

  // .mini-stats-wid {
  //   .media-body {
  //     p {
  //       font-weight: 500;
  //       font-size: 14px;
  //       color: #6C7589 !important;
  //     }

  //     h4 {
  //       font-weight: 800;
  //       font-size: 16px;
  //       color: #161B4D;
  //     }
  //   }
  // }
}
</style>
